// extracted by mini-css-extract-plugin
module.exports = {"box":"addressBox_box__2F1Gg"};